import  { useEffect, useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import usePageState from "../../../../utils/customHooks/usePageState";
import { STAUTES } from "../../../../utils/constant";
import { errorToast, successToast } from "../../../../utils/toastHelper";
import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { GET_ALL_COURSES, CREATE_STUDENT_ENROLLMENTS } from "../../../../utils/services/apiPath";
import { postApi } from "../../../../utils/services";
import useColumn from "../../../../utils/customHooks/useColumns";
import { ProGrid,dateColumnDef } from "@proscore-ai/proscore-ui-library";

export default function CourseEnrollment() {
  const { id } = useParams();
  const [englishSelection, setEnglishSelection] = useState([]);
  const [spanishSelection, setSpanishSelection] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [englishCourses, setEnglishCourses] = useState([]);
  const [spanishCourses, setSpanishCourses] = useState([]);
  const { currentPage, pageSize, data: coursesData, status, sortModel, searchString, setPageState, setStatus } = usePageState();
  
  const onCancel = () => {
    const alreadyEnglish = englishCourses.filter(item => item.isAlreadyApplied).map(item => item.id);
    const alreadySpanish = spanishCourses.filter(item => item.isAlreadyApplied).map(item => item.id);
    setEnglishSelection(alreadyEnglish);
    setSpanishSelection(alreadySpanish);
  };
  
  const onSave = async data => {
    if (isSaving) return;
    setIsSaving(true);
    setStatus(STAUTES.LOADING);
    
    const allSelectedCourses = [...englishSelection, ...spanishSelection];
    
    const payload = {
      courseIds: allSelectedCourses,
      employeeId: id
    };
    
    const { error } = await postApi(CREATE_STUDENT_ENROLLMENTS, payload);
    setIsSaving(false);
    if (error) return errorToast(error);
    
    successToast(`Employee has been enrollment to course successfully.`);
    setStatus(STAUTES.IDLE);
    
    getAllCourses();
  };
  
  const getAllCourses = useCallback(async () => {
    setStatus(STAUTES.LOADING);
    const payload = {
      pageIndex: searchString ? 1 : currentPage + 1,
      pageSize: pageSize,
      searchString: searchString,
      orderByAscending: true,
      orderCol: "",
      ...sortModel
    };
    const { data, totalRecords, error } = await postApi(GET_ALL_COURSES, payload, { params: { employeeId: id } });
    setStatus(STAUTES.IDLE);
    if (error) return errorToast(error);
    
    const english = data?.filter(course => course.language === 'en') || [];
    const spanish = data?.filter(course => course.language === 'es') || [];
    
    setEnglishCourses(english);
    setSpanishCourses(spanish);
    setPageState(prevPageInfo => ({ ...prevPageInfo, data: data || [], rowCount: totalRecords }));

    const alreadyEnglish = english.filter(item => item.isAlreadyApplied).map(item => item.id);
    const alreadySpanish = spanish.filter(item => item.isAlreadyApplied).map(item => item.id);
    
    setEnglishSelection(alreadyEnglish);
    setSpanishSelection(alreadySpanish);
  }, [currentPage, pageSize, sortModel, searchString, setPageState, setStatus, id]);
  
  const handleEnglishSelectionChange = newSelectionModel => {
    setEnglishSelection(newSelectionModel);
  };
  
  const handleSpanishSelectionChange = newSelectionModel => {
    setSpanishSelection(newSelectionModel);
  };
  
  useEffect(() => {
    getAllCourses();
  }, []);
  
  const columns = useColumn(
    [
      {
        field: "title",
        headerName: "Title",
        flex: 1,
        renderCell: params => {
          return <Box>{params.row.title.raw}</Box>;
        }
      },
      dateColumnDef({
        field: "date_created",
        headerName: "Created Date"
      })
    ],
    true
  );
  
  return (
    <Box sx={{ width: '100%' }}>
      {status === STAUTES.LOADING ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '500px' }}>
          <CircularProgress size={60} />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <ProGrid
              title="English Courses"
              loading={false}
              options={{
                getRowId: row => row.id,
                pagination: false,
                style: { maxHeight: "500px" }
              }}
              columns={columns}
              hideAddButton
              hideExport
              rows={englishCourses}
              rowSelectionModel={englishSelection}
              checkboxSelection
              onRowSelectionModelChange={handleEnglishSelectionChange}
            />
          </Grid>
          
          <Grid item xs={6}>
            <ProGrid
              title="Spanish Courses"
              loading={false}
              options={{
                getRowId: row => row.id,
                pagination: false,
                style: { maxHeight: "500px" }
              }}
              columns={columns}
              hideAddButton
              hideExport
              rows={spanishCourses}
              rowSelectionModel={spanishSelection}
              checkboxSelection
              onRowSelectionModelChange={handleSpanishSelectionChange}
            />
          </Grid>
        </Grid>
      )}
      
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, width: '100%' }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button className="cancel-btn" variant="outlined" color="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onSave} disabled={isSaving}>
            {isSaving ? (
              <>
                <CircularProgress size={24} />
                <span style={{ marginLeft: 10 }}>Save</span>
              </>
            ) : (
              "Save"
            )}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}